import Seo from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import { LegalBody, LegalSection } from "@/components/LegalPage";
import AmazonButton from "@/components/AmazonButton";
import { SITE } from "@/lib/site";

export default function ReturnsPolicy() {
  return (
    <>
      <Seo
        title="Returns Policy | AutoNeova"
        description="AutoNeova does not process orders or returns on this website. Returns for products purchased through Amazon are handled through the customer's Amazon account."
        path="/returns-policy"
      />
      <PageHeader
        testId="returns-page-header"
        eyebrow="Legal"
        title="Returns Policy"
        intro={`Effective Date: ${SITE.effectiveDate}`}
      />
      <LegalBody testId="returns-page-content">
        <p className="text-base leading-relaxed text-[#263238]">
          This website does not directly process orders or returns.
        </p>

        <LegalSection heading="1. Returns Are Handled Through Amazon">
          <p>
            Products purchased through Amazon are subject to the return and refund terms displayed on
            the applicable Amazon order or product page. Customers should initiate return requests
            through their Amazon account.
          </p>
        </LegalSection>

        <LegalSection heading="2. Where to Find the Applicable Terms">
          <p>
            The return window, refund method, and any conditions that apply to a specific purchase
            are shown on the relevant Amazon listing and within the customer's Amazon order details.
            Those terms govern the purchase.
          </p>
        </LegalSection>

        <LegalSection heading="3. General Inquiries">
          <p>
            If a customer is unable to resolve a return through Amazon, general business inquiries may
            be sent to{" "}
            <a
              href={`mailto:${SITE.email}`}
              data-testid="returns-email-link"
              className="font-semibold text-[#1F6FEB] underline decoration-[#1F6FEB]/30 underline-offset-4 hover:decoration-[#1F6FEB]"
            >
              {SITE.email}
            </a>
            . Order-level actions such as return authorization, refunds, and replacements are
            processed through Amazon.
          </p>
        </LegalSection>

        <div className="mt-12">
          <AmazonButton testId="returns-amazon-cta">Go to AutoNeova on Amazon</AmazonButton>
        </div>
      </LegalBody>
    </>
  );
}
